export default __webpack_public_path__ + "static/media/firefox.84530bd7.svg";